import merge from "deepmerge";
import { GetContractsRequest } from "../api/requests/get-contracts-request";
import { GetContractDetailsRequest } from "../api/requests/get-contract-details-request";
import { ErrorResponseWrapper } from "../api/errors/error-response-wrapper";
import { CreateContractQuestionRequest } from "../api/requests/create-contract-question-request";

import config from "../environment/environment-config";

/* Order header */
export const FETCH_CONTRACTS_BEGIN = "FETCH_CONTRACTS_BEGIN";
export const FETCH_CONTRACTS_SUCCESS = "FETCH_CONTRACTS_SUCCESS";
export const FETCH_CONTRACTS_FAILURE = "FETCH_CONTRACTS_FAILURE";

export const FETCH_CONTRACT_DETAILS_BEGIN = "FETCH_CONTRACT_DETAILS_BEGIN";
export const FETCH_CONTRACT_DETAILS_SUCCESS = "FETCH_CONTRACT_DETAILS_SUCCESS";
export const FETCH_CONTRACT_DETAILS_FAILURE = "FETCH_CONTRACT_DETAILS_FAILURE";

export const CREATE_CONTRACT_QUESTION_REQUEST_BEGIN =
  "CREATE_CONTRACT_QUESTION_REQUEST_BEGIN";
export const CREATE_CONTRACT_QUESTION_REQUEST_SUCCESS =
  "CREATE_CONTRACT_QUESTION_REQUEST_SUCCESS";
export const CREATE_CONTRACT_QUESTION_REQUEST_FAILURE =
  "CREATE_CONTRACT_QUESTION_REQUEST_FAILURE";

export const CONTRACTS_BASE_URL = config.apiUrls.contractsApi;

export const fetchContractsBegin = (request) => {
  return {
    type: FETCH_CONTRACTS_BEGIN,
    payload: request,
  };
};

export const fetchContractsSuccess = (contractsResponse) => ({
  type: FETCH_CONTRACTS_SUCCESS,
  payload: { contractsResponse },
});

export const fetchContractsFailure = (errors) => ({
  type: FETCH_CONTRACTS_FAILURE,
  payload: { errors },
});

/**
 * @jsdoc method
 * @name getContracts
 * @methodOf actions.contractsActions
 * @description description
 * Get contracts
 */
export function getContracts(
  request: GetContractsRequest,
  merge = false,
  contracts: any
) {
  const url = CONTRACTS_BASE_URL + request.toQueryString();

  return (dispatch) => {
    dispatch(fetchContractsBegin(request));
    return fetch(url, { credentials: "same-origin" })
      .then((res) => {
        if (!res.ok) {
          throw new ErrorResponseWrapper(res);
        } else {
          return res.json();
        }
      })
      .then((data) => {
        if (merge) {
          data.contracts = [...contracts, ...data.contracts];
        }
        dispatch(fetchContractsSuccess(data));
      })
      .catch((errorResponse: ErrorResponseWrapper) => {
        errorResponse.getErrorMessages().then((messages) => {
          dispatch(fetchContractsFailure(messages));
        });
      });
  };
}

export const fetchContractDetailsBegin = (request) => {
  return {
    type: FETCH_CONTRACT_DETAILS_BEGIN,
    payload: request,
  };
};

export const fetchContractDetailsSuccess = (contractsResponse) => ({
  type: FETCH_CONTRACT_DETAILS_SUCCESS,
  payload: { contractsResponse },
});

export const fetchContractDetailsFailure = (errors) => ({
  type: FETCH_CONTRACT_DETAILS_FAILURE,
  payload: { errors },
});

export function getContractDetails(
  request: GetContractDetailsRequest,
  contracts: any,
  id: string
) {
  const url = CONTRACTS_BASE_URL + request.toQueryString();
  return (dispatch) => {
    dispatch(fetchContractDetailsBegin(request));
    return fetch(url, { credentials: "same-origin" })
      .then((res) => {
        if (!res.ok) {
          throw new ErrorResponseWrapper(res);
        } else {
          return res.json();
        }
      })
      .then((data) => {
        const foundIndex = contracts.findIndex((x) => x.id === id);
        const oryginalInstallationLocation = [
          ...contracts[foundIndex].installationLocation,
        ];
        const multipleInstallationLocation = Object.assign(
          {},
          { value: contracts[foundIndex].multipleInstallationLocation }
        );

        contracts[foundIndex] = merge(contracts[foundIndex], data.contract);

        if (data.contract.installationLocation === null) {
          contracts[foundIndex].installationLocation =
            oryginalInstallationLocation;
          contracts[foundIndex].installationLocationList =
            oryginalInstallationLocation;
        } else if (
          oryginalInstallationLocation.length === 1 &&
          data.contract.installationLocation.length === 1
        ) {
          contracts[foundIndex].installationLocationList = [
            {
              position: data.contract.installationLocation[0].position,
              systemName: data.contract.installationLocation[0].systemName,
              installationAddress:
                oryginalInstallationLocation[0].installationAddress,
            },
          ];
        } else {
          contracts[foundIndex].installationLocation =
            oryginalInstallationLocation;
          contracts[foundIndex].installationLocationList =
            data.contract.installationLocation;
        }

        contracts[foundIndex].multipleInstallationLocation =
          multipleInstallationLocation.value;
        dispatch(fetchContractDetailsSuccess(contracts));
      })
      .catch((errorResponse: ErrorResponseWrapper) => {
        errorResponse.getErrorMessages().then((messages) => {
          dispatch(fetchContractDetailsFailure(messages));
        });
      });
  };
}

export const createContractQuestionRequestBegin = (guid) => {
  return {
    type: CREATE_CONTRACT_QUESTION_REQUEST_BEGIN,
    payload: { guid },
  };
};

export const createContractQuestionRequestSuccess = (guid, response) => ({
  type: CREATE_CONTRACT_QUESTION_REQUEST_SUCCESS,
  payload: { guid, response },
});

export const createContractQuestionRequestFailure = (guid, error) => ({
  type: CREATE_CONTRACT_QUESTION_REQUEST_FAILURE,
  payload: { guid, error },
});

export function createContractQuestionRequest(
  request: CreateContractQuestionRequest
) {
  const url = CONTRACTS_BASE_URL + `/question`;
  return async (dispatch) => {
    dispatch(createContractQuestionRequestBegin(request.contractNumber));
    const response = await fetch(url, {
      credentials: "same-origin",
      method: "POST",
      body: JSON.stringify(request),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      const data = await response.json();
      dispatch(
        createContractQuestionRequestSuccess(request.contractNumber, data)
      );
    } else {
      let data = undefined;

      try {
        data = await response.json();
      } catch (error) {}

      dispatch(
        createContractQuestionRequestFailure(
          request.contractNumber,
          data && "text" in data ? data.text : undefined
        )
      );
    }
  };
}
